import { createContext, useContext } from 'react'

export type ModalContextValue =
  | { ref: React.MutableRefObject<HTMLDivElement | null> }
  | undefined

const ModalContext = createContext<ModalContextValue>(undefined)
export const ModalContextProvider = ModalContext.Provider
export const useModalContext = () => useContext(ModalContext)
